export const appNames = {
    ControlCenter: 'ControlCenter',
    CriticalComms: 'CriticalComms',
    RiskIntelligence: 'RiskIntelligence',
    AssetUI: 'AssetUI',
    HistoricalReporting: 'HistoricalReporting',
    IncidentManagement: 'IncidentManagement',
    Microfrontend: 'Microfrontend'
};

export const orgIDEnum = {
    CODERED: 19,
    OP: 12
};
